<template>
  <div class="uk-container">
    <h1>Manage {{viewBy | capitalize}} Members</h1>
    <div class="uk-button-group uk-align-right">
      <DashboardSearch v-on:params="handleSearchParams" v-on:refresh="refreshSearch"/>

      <select class="uk-select" v-model="viewBy" v-on:change="refresh">
        <option value="active">View By: Active</option>
        <option value="booked">View By: Booked</option>
        <option value="refused">View By: Refused</option>
        <option value="absent">View By: Absent</option>
      </select>

      <vk-button type="primary" class="addMember" v-on:click="goToAddMember"><vk-icon icon="plus-circle"></vk-icon></vk-button>
    </div>
    <table class="uk-table">
      <thead>
        <th>#</th>
        <th>Notes</th>
        <th>Name</th>
        <th>Book #</th>
        <th>Phone Number</th>
        <th>Reg. Date</th>
        <th>Exp. Date</th>
        <th>Classes</th>
        <th>Certs</th>
        <th>Bookings</th>
        <th>Refusals</th>
        <th>Absences</th>
        <th>Remarks</th>
        <th>Actions</th>
      </thead>
      <tbody>
        <template v-for="(member, index) in members.slice((currentPage-1)*rowsPerPage, ((currentPage-1)*rowsPerPage+rowsPerPage))">
          <TableRow :member="member" :index="index+10*(currentPage-1)" v-on:refresh="refresh" v-bind:key="index"/>
        </template>
      </tbody>
    </table>
    <div class="pagination-buttons uk-pagination uk-flex-center">
      <span v-if="currentPage !== 1" >
        <a @click="currentPage-=1">&larr;</a>
      </span>
      <span v-for="(i,index) in pagination(currentPage, numPages)" v-bind:key="'nav-button-'+index">
        <a v-if="i !== '...'" @click="currentPage = i">{{i}}</a>
        <span v-else>...</span>
      </span>
      <span v-if="currentPage !== numPages" >
        <a @click="currentPage+=1">&rarr;</a>
      </span>
    </div>
  </div>
</template>

<script>
import MembersApi from "@/utils/api/members";
import TableRow from "./admin_queue_row.vue";
import DashboardSearch from "./admin_dashboard_search";

export default {
  name: "AdminDashboard",
  components: {
    TableRow,
    DashboardSearch
  },
  filters: {
    capitalize: function(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  },
  data() {
    return {
      loading: true,
      viewBy: "active",
      members: [],
      rowsPerPage: 10,
      numberRange: 2,
      currentPage: 1,
      numPages: 1
    };
  },
  created() {
    const searchParams = this.getSearchParams();
    if (searchParams) {
      const path = '?' + this.buildQueryString(searchParams);
      this.searchMembers(path);
    } else {
      this.fetchMembers();
    }
  },
  methods: {
    goToAddMember() {
      this.$router.push("/administration/members/create");
    },
    refresh() {
      this.fetchMembers(this.getViewByPage())
    },
    refreshSearch() {
      this.fetchMembers(this.getViewByPage(), 1);
    },
    getViewByPage() {
      switch (this.viewBy) {
        case "active":
          return "";
        case "booked":
          return "booked";
        case "refused":
          return "refused";
        case "absent":
          return "absent";
      }
    },
    fetchMembers(path = "", page = null) {
      MembersApi.getMembers(this.$cookie.get("iwl_apiToken"), path)
        .then(members => {
          if (page !== null) this.currentPage = 1;
          this.members = members;
          this.numPages = Math.ceil(members.length / this.rowsPerPage);
        })
        .catch(error => console.log(error));
    },
    searchMembers(path) {
      MembersApi.submitSearch(this.$cookie.get("iwl_apiToken"), path)
        .then(members => {
          this.members = members;
          this.numPages = Math.ceil(members.length / this.rowsPerPage);
        })
        .catch(error => console.log(error));
    },
    pagination(currentPage, nrOfPages) {
      var delta = 2,
        range = [],
        rangeWithDots = [],
        l;

      range.push(1);

      if (nrOfPages <= 1) {
        return range;
      }

      for (let i = currentPage - delta; i <= currentPage + delta; i++) {
        if (i < nrOfPages && i > 1) {
          range.push(i);
        }
      }
      range.push(nrOfPages);

      for (let i of range) {
        if (l) {
          if (i - l === 2) {
            rangeWithDots.push(l + 1);
          } else if (i - l !== 1) {
            rangeWithDots.push("...");
          }
        }
        rangeWithDots.push(i);
        l = i;
      }

      return rangeWithDots;
    },
    getSearchParams() {
      if (sessionStorage.searchParams) {
        return JSON.parse(sessionStorage.searchParams);
      }

      return undefined;
    },
    handleSearchParams() {
      const path = '?' + this.buildQueryString(this.getSearchParams());
      this.searchMembers(path);
    },
    buildQueryString(searchParams) {
      var params = [];

      if (searchParams.includeInactive) {
        params.push("inactive");
      }
      if (searchParams.fName !== "") {
        params.push("fname=" + searchParams.fName);
      }
      if (searchParams.lName !== "") {
        params.push("lname=" + searchParams.lName);
      }
      if (searchParams.bookNum !== "") {
        params.push("booknum=" + searchParams.bookNum);
      }
      if (searchParams.classifications !== []) {
        for (var i = 0; i < searchParams.classifications.length; i++) {
          params.push("class=" + searchParams.classifications[i]);
        }
      }
      if (searchParams.certifications !== []) {
        for (var i = 0; i < searchParams.certifications.length; i++) {
          params.push("cert=" + searchParams.certifications[i]);
        }
      }

      return params.join("&");
    }
  }
};
</script>

<style scoped>
h1 {
  float: left;
  margin-bottom: 50px;
}
table {
  width: 100%;
  font-size: 13px;
}
.uk-select {
  width: auto;
}
.uk-button-group {
  margin-top: 6px;
}
.uk-button-group > .uk-button:nth-child(n + 2) {
  clear: both;
  margin-right: -4px;
  margin-left: -4px;
}
.uk-align-right div {
  display: inline-block;
}
.pagination-buttons {
  margin-top: 70px;
}
.pagination-buttons a {
  color: #1e87f0;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin_dashboard.vue